import '../application'

import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
Rails.start()
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
Turbolinks.start()
